export function createEmptyObjectFromSchema(schema: any): Record<string, any> {
  if (!schema || !schema.properties) {
    return {};
  }

  const result: Record<string, any> = {};

  Object.keys(schema.properties).forEach(key => {
    const propSchema = schema.properties[key];

    if (propSchema.type === 'object' && propSchema.properties) {
      result[key] = createEmptyObjectFromSchema(propSchema);
    } else if (propSchema.type === 'array' && propSchema.items) {
      result[key] = [];
    } else if (propSchema.type === 'integer' || propSchema.type === 'number') {
      result[key] = propSchema.default !== undefined ? propSchema.default : 0;
    } else {
      result[key] = propSchema.default !== undefined ? propSchema.default : '';
    }
  });

  return result;
}

export function handleFieldChange(formData: Record<string, any>, key: string, value: any, propertyType?: string): Record<string, any> {
  const processedValue = propertyType === 'integer' || propertyType === 'number' ? parseFloat(value) || 0 : value;

  return {
    ...formData,
    [key]: processedValue,
  };
}

export function handleNestedFieldChange(formData: Record<string, any>, parentKey: string, childKey: string, value: any, propertyType?: string): Record<string, any> {
  const processedValue = propertyType === 'integer' || propertyType === 'number' ? parseFloat(value) || 0 : value;

  return {
    ...formData,
    [parentKey]: {
      ...formData[parentKey],
      [childKey]: processedValue,
    },
  };
}

export function handleArrayItemChange(formData: Record<string, any>, arrayKey: string, index: number, itemKey: string, value: any, propertyType?: string): Record<string, any> {
  const processedValue = propertyType === 'integer' || propertyType === 'number' ? parseFloat(value) || 0 : value;

  const nextArray = [...formData[arrayKey]];
  nextArray[index] = {
    ...nextArray[index],
    [itemKey]: processedValue,
  };

  return {
    ...formData,
    [arrayKey]: nextArray,
  };
}

export function handlePrimitiveArrayItemChange(formData: Record<string, any>, key: string, index: number, value: any, propertyType: string): Record<string, any> {
  let processedValue = value;

  if (propertyType === 'integer') {
    processedValue = value === '' ? 0 : parseInt(value, 10);
  } else if (propertyType === 'number') {
    processedValue = value === '' ? 0 : parseFloat(value);
  } else if (propertyType === 'boolean') {
    processedValue = value === 'true';
  }

  const newArray = [...formData[key]];
  newArray[index] = processedValue;

  return {
    ...formData,
    [key]: newArray,
  };
}

export function prepareRequest(formData: Record<string, any>, agentSchemaProperties: Record<string, any>): Record<string, any> {
  const request: Record<string, any> = {};

  Object.entries(formData).forEach(([key, value]) => {
    const propertySchema = agentSchemaProperties[key];

    if (!propertySchema) {
      request[key] = value;
      return;
    }

    if (propertySchema.type === 'object' && propertySchema.properties && typeof value === 'object') {
      // Process nested object
      request[key] = prepareRequest(value, propertySchema.properties);
    } else if (propertySchema.type === 'array' && Array.isArray(value) && propertySchema.items) {
      // Process array items
      if (propertySchema.items.type === 'object' && propertySchema.items.properties) {
        request[key] = value.map(item => prepareRequest(item, propertySchema.items.properties));
      } else {
        request[key] = value;
      }
    } else if (propertySchema.type === 'integer' && value !== '') {
      // Convert string to integer
      request[key] = parseInt(value, 10);
    } else if (propertySchema.type === 'number' && value !== '') {
      // Convert string to float
      request[key] = parseFloat(value);
    } else {
      request[key] = value;
    }
  });

  return request;
}
